(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-result/assets/utils.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-result/assets/utils.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const drawgamesApiCaller = svs.tur.apiCaller.drawgames;
const productMapping = svs.lyckoplatsen.components.shared_constants.productMapping;
const fetchNewDates = async (year, month) => {
  const product = productMapping.getProductDrawId(productMapping.CONSTANTS.LYCKOPLATSEN, 'getDrawResultsDatepicker');
  try {
    var _resp$response$result, _resp$response;
    const resp = await drawgamesApiCaller.getDrawResultsDatepicker({
      product,
      year,
      month
    });
    return {
      resultDates: (_resp$response$result = (_resp$response = resp.response) === null || _resp$response === void 0 ? void 0 : _resp$response.resultDates) !== null && _resp$response$result !== void 0 ? _resp$response$result : resp.resultDates,
      product,
      year,
      month
    };
  } catch (e) {
    svs.lyckoplatsen.logger.warn('Failed to get result dates', e);
    return [];
  }
};
async function fetchResult(product, drawNumber) {
  try {
    var _resp$response$result2, _resp$response2;
    const resp = await drawgamesApiCaller.getDrawProductDrawsResult({
      product: productMapping.getProductDrawId(product),
      drawNumber
    });
    return (_resp$response$result2 = resp === null || resp === void 0 || (_resp$response2 = resp.response) === null || _resp$response2 === void 0 ? void 0 : _resp$response2.result) !== null && _resp$response$result2 !== void 0 ? _resp$response$result2 : resp === null || resp === void 0 ? void 0 : resp.result;
  } catch (e) {
    svs.lyckoplatsen.logger.info('Failed to get result', e);
  }
}
async function fetchSpan(span) {
  try {
    var _resp$response$spanRe, _resp$response3;
    const resp = await drawgamesApiCaller.getDrawProductDrawsResultByspan({
      product: productMapping.getProductDrawId(productMapping.CONSTANTS.LYCKOPLATSEN, 'getDrawProductDrawsResultByspan'),
      days: span
    });
    return (_resp$response$spanRe = resp === null || resp === void 0 || (_resp$response3 = resp.response) === null || _resp$response3 === void 0 ? void 0 : _resp$response3.spanResults) !== null && _resp$response$spanRe !== void 0 ? _resp$response$spanRe : resp === null || resp === void 0 ? void 0 : resp.spanResults;
  } catch (e) {
    svs.lyckoplatsen.logger.info('Failed to get result', e);
  }
}
const memoFetchNewDates = _.memoize(fetchNewDates, (year, month) => "".concat(year, "-").concat(month));
const memoFetchResult = _.memoize(fetchResult, (product, drawNumber) => "".concat(product, "-").concat(drawNumber));
const memoFetchSpan = _.memoize(fetchSpan, span => "".concat(span));
const formatAvailableDates = _ref => {
  let resultDates = _ref.resultDates,
    year = _ref.year,
    month = _ref.month;
  const datesInMonth = {};
  resultDates === null || resultDates === void 0 || resultDates.forEach(resultDate => {
    const date = new Date(resultDate.date);
    const y = date.getFullYear();
    const m = date.getMonth() + 1;
    if (y === parseInt(year, 10) && m === parseInt(month, 10)) {
      const dateInMonth = date.getDate();
      if (!datesInMonth[dateInMonth]) {
        datesInMonth[dateInMonth] = [];
      }
      datesInMonth[dateInMonth].push(resultDate);
    }
  });
  return datesInMonth;
};
const noAdjacent = _ref2 => {
  let resultArray = _ref2.resultArray,
    topValue = _ref2.topValue;
  const result = new Array(resultArray.length);
  const nonTopValues = [];
  for (let i = 0; i < resultArray.length; i++) {
    if (resultArray[i] === topValue) {
      result[i] = resultArray[i];
      continue;
    }
    nonTopValues.push(resultArray[i]);
  }
  const frequencyMap = new Map();
  for (const value of nonTopValues) {
    frequencyMap.set(value, (frequencyMap.get(value) || 0) + 1);
  }
  let frequencyArray = [...frequencyMap.entries()].sort((_ref3, _ref4) => {
    let _ref5 = _slicedToArray(_ref3, 2),
      aValue = _ref5[0],
      aFrequency = _ref5[1];
    let _ref6 = _slicedToArray(_ref4, 2),
      bValue = _ref6[0],
      bFrequency = _ref6[1];
    return bFrequency - aFrequency || aValue - bValue;
  });
  const reordered = [];
  const leftovers = [];
  let lastPlaced = null;
  function pickNext() {
    frequencyArray.sort((_ref7, _ref8) => {
      let _ref9 = _slicedToArray(_ref7, 2),
        aValue = _ref9[0],
        aFrequency = _ref9[1];
      let _ref0 = _slicedToArray(_ref8, 2),
        bValue = _ref0[0],
        bFrequency = _ref0[1];
      return bFrequency - aFrequency || aValue - bValue;
    });
    for (let i = 0; i < frequencyArray.length; i++) {
      const _frequencyArray$i = _slicedToArray(frequencyArray[i], 2),
        value = _frequencyArray$i[0],
        frequency = _frequencyArray$i[1];
      if (frequency > 0 && value !== lastPlaced) {
        frequencyArray[i] = [value, frequency - 1];
        return value;
      }
    }
    return null;
  }
  while (frequencyArray.length > 0) {
    const nextValue = pickNext();
    if (nextValue === null) {
      break;
    }
    reordered.push(nextValue);
    lastPlaced = nextValue;
    frequencyArray = frequencyArray.filter(_ref1 => {
      let _ref10 = _slicedToArray(_ref1, 2),
        frequency = _ref10[1];
      return frequency > 0;
    });
  }
  frequencyArray.forEach(_ref11 => {
    let _ref12 = _slicedToArray(_ref11, 2),
      value = _ref12[0],
      frequency = _ref12[1];
    while (frequency-- > 0) {
      leftovers.push(value);
    }
  });
  const mergedOrder = reordered.concat(leftovers);
  let index = 0;
  for (let i = 0; i < result.length; i++) {
    if (result[i] === undefined) {
      result[i] = mergedOrder[index++];
    }
  }
  return result;
};
const getDistributionArray = _ref13 => {
  let winPlan = _ref13.winPlan,
    win = _ref13.win,
    drawNumber = _ref13.drawNumber;
  const COLORS = {
    even: '#2073E5',
    odd: '#1047B8',
    special: '#001932'
  };
  const totalItems = 40;
  const items = winPlan.map(item => _objectSpread(_objectSpread({}, item), {}, {
    probability: parseFloat(item.probability.replace(',', '.')),
    amountValue: parseFloat(item.amountSek.replace(',', '.'))
  }));
  const sortedByAmount = [...items].sort((a, b) => a.amountValue - b.amountValue);
  const lowestAmountSek = parseInt(sortedByAmount[0].amountSek, 10);
  const counts = items.map(item => Math.round(item.probability / 100 * totalItems));
  const remainder = totalItems - counts.reduce((sum, c) => sum + c, 0);
  let result = items.flatMap((item, i) => Array(counts[i]).fill(parseInt(item.amountSek, 10)));
  result = result.concat(Array(remainder).fill(lowestAmountSek));
  const topValueItem = sortedByAmount[sortedByAmount.length - 1];
  const topValue = parseInt(topValueItem.amountSek, 10);
  const topValues = result.filter(v => v === topValue);
  const topCount = topValues.length;
  if (topCount > 0) {
    const others = result.filter(v => v !== topValue);
    for (let i = others.length - 1; i > 0; i--) {
      const rand = Math.floor(Math.random() * (i + 1));
      var _ref14 = [others[rand], others[i]];
      others[i] = _ref14[0];
      others[rand] = _ref14[1];
    }
    const newResult = new Array(totalItems).fill(null);
    for (let i = 0; i < topCount; i++) {
      newResult[Math.round(i * totalItems / topCount)] = topValue;
    }
    let otherIndex = 0;
    for (let i = 0; i < newResult.length; i++) {
      if (newResult[i] === null) {
        newResult[i] = others[otherIndex++];
      }
    }
    result = noAdjacent({
      resultArray: newResult,
      topValue
    });
  }
  const distribution = result.map((value, index) => {
    let color = index % 2 === 0 ? COLORS.even : COLORS.odd;
    if (value === topValue) {
      color = COLORS.special;
    }
    return {
      value,
      isWin: false,
      color
    };
  });
  const winnableValues = distribution.filter(_ref15 => {
    let value = _ref15.value;
    return value === win;
  });
  const randomWinner = drawNumber * 2654435761 >>> 0;
  winnableValues[randomWinner % winnableValues.length].isWin = true;
  return distribution;
};
setGlobal('svs.lyckoplatsen.utils.page_result', {
  memoFetchNewDates,
  formatAvailableDates,
  memoFetchResult,
  memoFetchSpan,
  getDistributionArray
});

 })(window);